/** Tax in the web app: Billing → Tax (rules, settings, EU VAT, calculator). */
export default {
  name: 'tax',
  adminRoutes: [{ path: 'billing/tax', lazy: () => import('./TaxPage.jsx').then((m) => ({ Component: m.TaxPage })) }],
  adminNav: [
    { section: 'billing_settings', to: '/admin/billing/tax', label: 'Tax', permission: 'admin.tax.manage', order: 30 },
  ],
};
